import { Datepicker } from "flowbite-react";
import { useEffect, useState } from "react";

const DateInput = ({ value, onChange, autoFocus = false }) => {
  const [selectedDate, setSelectedDate] = useState(
    value ? new Date(value) : new Date(),
  );

  useEffect(() => {
    if (value) {
      setSelectedDate(new Date(value));
    } else {
      setSelectedDate(new Date());
    }
  }, [value]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (date) {
      // Format date as YYYY-MM-DD using local timezone (not UTC)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;
      onChange(formattedDate);
    } else {
      onChange("");
    }
  };

  const customTheme = {
    popup: {
      root: {
        inner:
          "inline-block rounded-lg bg-white p-4 border border-gray-300 w-full mb-2 shadow-lg",
      },
    },
    views: {
      days: {
        items: {
          base: "grid w-full grid-cols-7",
          item: {
            base: "block flex-1 cursor-pointer rounded-lg border-0 text-center text-sm font-semibold leading-9 text-gray-900 hover:bg-gray-100",
            selected: "bg-pink text-white hover:bg-pink",
            disabled: "text-gray-400",
          },
        },
      },
    },
  };

  return (
    <div className="w-full">
      <Datepicker
        theme={customTheme}
        inline
        value={selectedDate}
        onChange={handleDateChange}
        weekStart={1}
        showClearButton={false}
        showTodayButton={false}
        autoFocus={autoFocus}
      />
    </div>
  );
};

export default DateInput;
